import React, { Children, createContext } from 'react'
import { useState } from 'react';

 export const AuthContext = createContext();

 export const AuthProvider = (props) => {
  const [usuario, setUsuario] = useState();
  const [logueado, setLogueado] = useState(false);

  const onLogin =(usuario,password) =>{
    const data = new FormData();
    data.append('usuario', usuario);
    data.append('password', password);
     fetch(process.env.REACT_APP_API_URL+'/usuarios.php?funcion=login&usuario='+usuario+'&password='+password, {
      method:'POST',
      body:data
     })
     .then(response =>response.json())
     .then(data=> {
       console.log('Datos obtenidos del api',data);
       if(data?.IdUsuario) {
        setLogueado(true);
        setUsuario(data)
       }
     })
  }
  return(
  <AuthContext.Provider 
    value={{
      usuario,
      logueado,
      setUsuario,
      setLogueado, 
      onLogin, 
    }}
  >
    {props.children}
  </AuthContext.Provider>
  )
}

